import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BannerImg from "../../../images/locationgcc/sa/game-sa/Ensure.webp";

function Banner(props) {
  return (
    <div
      className="revolution_gcc p-100"
      style={{
        backgroundImage: `url(${BannerImg})`,
        backgroundPosition: "left",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="ms-auto">
            <h2>
              Ensure Optimal Business Growth with Our Full Game Development
            </h2>
            <p>
              Extend the scale of your business growth with our innovative game
              development services. Engaging games goes beyond entertainment as
              they're powerful tools for enhancing the brand image. That’s how
              you can expand your audience, leading towards the maximum revenue
              generation. We assist businesses to leverage the potential of
              gaming to achieve their goals with our full suite of game
              development in Saudi Arabia.
            </p>
            <p>
              From mobile games that boost user engagement to next-gen VR
              experiences that revolutionize brand perception, we ensure
              profitable results with our game app development. We are experts
              in monetization strategies and user retention techniques. As a
              result, we ensure your games generate revenue and help you sustain
              the continual growth of your business.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Consult with Us Today!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
